<template>
  <footer
    class="
      flex flex-shrink-0
      items-center
      justify-center
      p-6
      text-core text-opacity-40 text-xs
      font-normal
    "
    :class="{ 'tracking-wider': isCustomFont }"
  >
    <span class="mr-1">{{ $t('youRateThanksTo') }}</span>
    <a class="font-semibold" :href="url" target="_blank">LocalZen </a>
  </footer>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { LINKS } from '@/const/links';

@Component({
  name: 'survey-page-footer',
})
export default class SurveyPageFooter extends Vue {
  private url = LINKS.LOCAL_ZEN;

  private get isCustomFont() {
    return this.$store.getters.isVox;
  }
}
</script>
